import {getStorageInfo} from "../js/storage";

export const getUserType = function (user) {
    user = user || getStorageInfo();
    return user.type || 2;
}

export const getRoleTypeText = function (user) {
    const type = getUserType(user);
    let res = '工作人员';
    if(type == 1) {
        res = '超级管理员';
    }
    return res;
}

export const getRoleActivitySubMenus = function (activity, user) {
    const type = getUserType(user);
    const id = activity.id;
    let res = [];
    switch (type) {
        case 1:
            res = [
                {
                    title: '概览',
                    path: `/act/${id}/info`
                },
                {
                    title: '小组设置',
                    path: `/act/${id}/group`
                },
                {
                    title: '工作人员管理',
                    path: `/act/${id}/staff`
                },
                {
                    title: '首页装修',
                    path: `/act/${id}/furnish`,
                    children: [
                        {
                            title: '日程管理',
                            path: `/act/${id}/schedule`
                        },
                        {
                            title: '文章列表',
                            path: `/act/${id}/article`
                        },
                        {
                            title: '视频列表',
                            path: `/act/${id}/video`
                        },
                    ]
                },
                {
                    title: '用餐管理',
                    path: `/act/${id}/dinner`,
                    children: [
                        {
                            title: '用餐分配',
                            path: `/act/${id}/meal-assign`
                        },
                        {
                            title: '用餐信息',
                            path: `/act/${id}/meal-info`
                        },
                        {
                            title: '用餐规格',
                            path: `/act/${id}/meal`
                        },
                    ]
                },
                {
                    title: '住宿管理',
                    path: `/act/${id}/stay`,
                    children: [
                        {
                            title: '住宿分配',
                            path: `/act/${id}/stay-assign`
                        },
                        {
                            title: '住宿信息',
                            path: `/act/${id}/stay-info`
                        },
                        {
                            title: '酒店管理',
                            path: `/act/${id}/hotel`
                        },
                        {
                            title: '房间管理',
                            path: `/act/${id}/room`
                        },
                    ]
                },
                {
                    title: '礼品管理',
                    path: `/act/${id}/present`,
                    children: [
                        {
                            title: '礼品分配',
                            path: `/act/${id}/gift-assign`
                        },
                        {
                            title: '礼品规格',
                            path: `/act/${id}/gift`
                        },
                    ]
                },
                {
                    title: '交通管理',
                    path: `/act/${id}/traffic`,
                    children: [
                        {
                            title: '司机管理',
                            path: `/act/${id}/driver`
                        },
                        {
                            title: '车辆管理',
                            path: `/act/${id}/vehicle`
                        },
                        {
                            title: '通行证管理',
                            path: `/act/${id}/pass`
                        },
                    ]
                },
                {
                    title: '接待人员管理',
                    path: `/act/${id}/receptionist`
                },
            ];
            break;
        case 2:
            res = [
                {
                    title: '概览',
                    path: `/act/${id}/info`
                },
            ];
            break;
    }
    return res;
}

